export default () => ({
  icon: {
    margin: '16px 10px 0 0'
  }
})
